<template>
  <v-row v-scroll="onScroll">
    <!-- header -->
    <mini-header title="Resumen del proveedor" :dense="true" :breadcrumbs="breadcrumbs" :breadcrumbsItemDinamic="{ loading: $store.state.suppliers.retrieveLoader, text: instance.name }" :hiddenTab="true" :addPadding="true" :scroll="scroll">
      <template v-slot:main>
        <v-btn @click="dialogConfirmLock=true" outlined :ripple="false" v-if="($helpers.hasSomePermission(['view_suppliergroup']) && $store?.state?.auth?.account?.suppliergroup_feature)">
          <v-icon left>mdi-lock{{ currentSegment?.name === 'Bloqueados' ? '-open' : '' }}</v-icon> {{ currentSegment?.name !== 'Bloqueados' ? 'Bloquear' : 'Desbloquear' }} proveedor
        </v-btn>
        <v-btn class="ml-2" @click="openEditDialog" color="blue-500" :ripple="false">
          <v-icon left>mdi-pencil</v-icon> Editar proveedor
        </v-btn>
      </template>
    </mini-header>
    <!-- end header -->
    <v-col class="pa-0 mt-20" style="z-index: 0;">
      <skeleton-detail v-if="loading" />
      <div class="d-flex" v-else>
        <!-- <PermissionDenied v-if="!$helpers.hasPermission(['view_supplier'])" /> -->
        <template >
          <!-- detail card -->
          <div class="mr-6" style="min-width: 400px;">
            <div :style="isFixed">
              <v-alert text outlined class="inf-alert-error" color="red-500" rounded dense :width="400" v-if="currentSegment?.name === 'Bloqueados'">
                <div class="d-flex pa-0 align-center">
                  <v-icon color="red-500">mdi-lock</v-icon>
                  <div class="ml-4 alert-description">
                    <span class="body-1 font-weight-bold red-500--text">Proveedor bloqueado</span>
                    <span class="d-block body-2 pb-11 red-500--text" style="line-height: 1.3">
                      Los documentos de este proveedor son reclamados automaticamente desde el
                      <span class="font-weight-medium">{{ instance?.group_assigned_date | dateTimeSecond}}</span>
                    </span>
                  </div>
                </div>
              </v-alert>
              <v-card class="blue-500" width="400">
                <v-card-text>
                  <span class="subtitle-2 white--text font-weight-bold d-inline-block text-truncate" style="max-width: 90%;">
                    {{instance.name}}
                  </span>
                  <span class="d-block subtitle-2 white--text">{{instance.tax_id}}</span>
                  <div class="mt-4">
                    <span class="d-block body-1 white--text">Actividad económica</span>
                    <span class="subtitle-2 white--text">
                      <span class="font-weight-bold" v-if="instance?.business_activity">{{instance?.business_activity}}</span>
                      <span class="body-2 grey-200--text font-italic" v-else>Sin especificar</span>
                    </span>
                  </div>
                  <div class="mt-4">
                    <span class="d-block body-1 white--text">Dirección</span>
                    <span class="subtitle-2 white--text">
                      <span class="font-weight-bold" v-if="instance?.address">{{instance.address}}</span>
                      <span class="body-2 grey-200--text font-italic" v-else>Sin especificar</span>
                    </span>
                  </div>
                  <div class="mt-4">
                    <span class="d-block body-1 white--text">Comuna</span>
                    <span class="subtitle-2 white--text">
                      <span class="font-weight-bold" v-if="instance?.municipality">{{instance.municipality}}</span>
                      <span class="body-2 grey-200--text font-italic" v-else>Sin especificar</span>
                    </span>
                  </div>
                  <div class="d-flex justify-space-between">
                    <div class="mt-4">
                      <span class="d-block body-1 white--text">Creado el</span>
                      <span class="subtitle-2 white--text">
                        <span class="font-weight-bold" v-if="instance?.created">{{instance.created | dateTimeSecond}}</span>
                        <span class="body-2 grey-200--textfont-italic" v-else>Sin especificar</span>
                      </span>
                    </div>
                    <div class="mt-4">
                      <span class="d-block body-1 white--text">Actualizado el</span>
                      <span class="subtitle-2 white--text">
                        <span class="font-weight-bold" v-if="instance?.updated">{{instance.updated | dateTimeSecond}}</span>
                        <span class="body-2 grey-200--text font-italic" v-else>Sin especificar</span>
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
              <v-card v-if="$store?.state?.auth?.account?.options?.includes('rec_process_rules')" class="pa-0 mt-4" width="400" transition="slide-y-transition" flat>
                <v-toolbar color="transparent" flat height="46">
                  <v-toolbar-title class="px-5 subtitle-2 grey-500--text font-weight-bold d-flex align-center">
                    <v-icon size="18" left color="grey-500">mdi-folder</v-icon>
                    Categoría
                  </v-toolbar-title>
                </v-toolbar>
                <v-divider />

                <v-card-text class="py-2 px-5">
                  <v-list class="v-list-form-main transparent pa-0">
                    <v-list-item class="pa-0">
                      <v-list-item-icon class="mr-4">
                        <v-avatar :color="isDefaultCategory ? 'yellow-100' : 'blue-100'" :size="28">
                          <v-icon :color="isDefaultCategory ? 'yellow-500' : 'blue-500'" :size="16">mdi-folder</v-icon>
                        </v-avatar>
                      </v-list-item-icon>
                      <v-avatar v-if="$store.state.suppliers.retrieveLoader" tile class="placeholder rounded-pill" height="15" width="300" />
                      <v-list-item-title class="grey-500--text body-1 font-weight-semibold d-inline-block text-truncate" v-else style="max-width: 90%;">
                        <v-chip v-if="currentSegment?.name === 'Bloqueados'" color="greyMedium" class="font-weight-semibold" small label>Bloqueados<v-icon right>mdi-lock</v-icon></v-chip>
                        <router-link v-else-if="currentSegment?.id" :to="{ name: 'SuppliersCategoriesRetrieveUpdate', params: { id: currentSegment.id, ...currentParams } }" class="text-decoration-none blue-500--text">{{ currentSegment.name }}</router-link>
                        <router-link v-else :to="{ name: 'SuppliersCategoriesRetrieveUpdate', params: { id: 'se_AAAAAAAAAAAAAAAA', ...currentParams } }" class="text-decoration-none grey-500--text">Sin categoría asociada</router-link>
                        </v-list-item-title>
                      <v-list-item-action>
                        <v-menu close-on-click close-on-content-click offset-y left :nudge-bottom="10" :nudge-left="10" transition="slide-y-transition">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn class="mr-n4" :disabled="['Bloqueados'].includes(currentSegment?.name)" v-bind="attrs" v-on="on" text x-small><v-icon color="grey-500" size="24">mdi-dots-vertical</v-icon></v-btn>
                          </template>
                          <v-list class="pa-0">
                            <v-list-item class="px-3" v-if="instance.segment_id && instance.segment_id.length > 0 && instance.segment_id !== 'se_AAAAAAAAAAAAAAAA'" @click="handleDelete" :ripple="false">
                              <v-list-item-title class="body-2 d-flex align-center">
                                <v-icon color="grey-500" size="16" left>mdi-folder-minus</v-icon>Eliminar de la categoría
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item class="px-3" v-if="!instance.segment_id || instance.segment_id.length === 0 || instance.segment_id === 'se_AAAAAAAAAAAAAAAA'" @click="handleAdd" :ripple="false">
                              <v-list-item-title class="body-2 d-flex align-center">
                                <v-icon color="grey-500" size="16" left>mdi-folder-plus</v-icon>Agregar a categoría
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item class="px-3" v-if="instance.segment_id && instance.segment_id.length > 0 && instance.segment_id !== 'se_AAAAAAAAAAAAAAAA'" @click="handleChange" :ripple="false">
                              <v-list-item-title class="body-2 d-flex align-center">
                                <v-icon color="grey-500" size="16" left>mdi-swap-horizontal</v-icon>Cambiar de categoría
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-card-text>
              </v-card>
              <v-card class="pa-0 mt-4" width="400" transition="slide-y-transition" flat v-if="$store?.state?.auth?.account?.options?.includes('rec_process_rules') && currentSegment?.automatization_name && currentSegment?.automatization_action">
                <v-toolbar color="transparent" flat height="46">
                  <v-toolbar-title class="px-5 subtitle-2 grey-500--text font-weight-bold d-flex align-center">
                    <v-icon size="18" left color="grey-500">mdi-flash</v-icon>
                    Automatización
                  </v-toolbar-title>
                </v-toolbar>
                <v-divider />

                <v-card-text class="py-5 px-5">
                  <v-list class="v-list-form-main transparent pa-0" v-if="($helpers.hasSomePermission(['view_suppliergroup']) && $store?.state?.auth?.account?.suppliergroup_feature)" three-line>
                    <v-list-item class="pa-0">
                      <v-list-item-subtitle class="grey-500--text body-1 font-weight-semibold">
                        <template v-if="currentSegment?.automatization_name">{{ currentSegment?.automatization_name}}</template>
                        <span class="body-2 text--disabled font-italic" v-else>Sin especificar</span>
                        </v-list-item-subtitle>
                    </v-list-item>
                  </v-list>
                  <div class="mt-3" v-if="currentSegment?.automatization_action">
                    <v-chip class="font-weight-semibold" :color="statusChip[currentSegment?.automatization_action?.toLowerCase()]?.color" small label>{{ statusChip[currentSegment?.automatization_action?.toLowerCase()]?.key }}<v-icon right>mdi-{{statusChip[currentSegment?.automatization_action?.toLowerCase()]?.icon}}</v-icon></v-chip>
                  </div>
                </v-card-text>
              </v-card>
            </div>
          </div>
          <!-- end summary -->

          <!-- panels -->
          <div class="mb-8" style="flex:1; min-width: 200px;">
            <!-- contacts - oculto -->
            <!-- <v-expansion-panels v-model="contactPanel">
              <v-expansion-panel>
                <v-expansion-panel-header class="px-5 py-4">
                  <v-row no-gutters align="center">
                    <span class="ml-n1 subtitle-2 grey-500--text font-weight-bold"><v-icon class="mr-2" small color="grey-500">mdi-account</v-icon>Contactos</span>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="px-0">
                  <v-divider />
                  <v-skeleton-loader class="rounded-md" v-if="contactsLoading" transition="fade-transition" type="table-tbody" />
                  <template v-else>
                    <v-empty-state class="mt-5 pb-2" v-if="!contactsList.length" type="customer-econ" id="documentos" customClass="mt-5" :isFree="true" title="Aun no tienes contactos" :height="139" />
                    <v-simple-table class="table-not-rounded no-hover pt-0 pb-1 px-2 transparent" v-else dense>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left grey-500--text font-weight-medium" style="min-width: 180px;"><v-icon class="ml-n2" small left color="grey-500">mdi-account</v-icon>Nombre</th>
                            <th class="text-left grey-500--text font-weight-medium" style="min-width: 180px;"><v-icon small left color="grey-500">mdi-email</v-icon>Email</th>
                            <th style="min-width: 50px;" class="text-right grey-500--text font-weight-medium"><v-icon small left color="grey-500">mdi-phone</v-icon>Telefono</th>
                            <th style="min-width: 60px;"/>
                          </tr>
                          <v-divider style="position: absolute;  margin-top: -6px; min-width: 100%; margin-left: -8px" />
                        </thead>
                        <tbody>
                          <tr v-for="contact in contactsList" :key="contact.id">
                            <td class="body-2">
                              <span class="d-inline-block text-truncate ml-n1" v-if="contact.name" style="max-width: 100%;">{{contact.name}}</span>
                              <span class="body-2 text--disabled font-italic" v-else>Sin especificar</span>
                            </td>
                            <td class="text-left body-2" style="min-width: 180px;">
                              <span class="d-inline-block text-truncate" style="max-width: 100%;">{{contact.email}}</span>
                            </td>
                            <td class="text-right body-2">
                              <span v-if="contact.phone">{{contact.phone}}</span>
                              <span class="body-2 text--disabled font-italic" v-else>Sin especificar</span>
                            </td>
                            <td class="text-right body-2">
                              <v-menu close-on-click close-on-content-click offset-y left :nudge-left="10" :nudge-bottom="10" transition="slide-y-transition">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn class="mr-n4" v-bind="attrs" v-on="on" text x-small><v-icon color="grey-500" size="24">mdi-dots-vertical</v-icon></v-btn>
                                </template>
                                <v-list class="pa-0">
                                  <v-list-item class="px-3" @click="destroy(contact.id)" :ripple="false">
                                    <v-list-item-title class="body-2"><v-icon color="grey-500" size="20" left>mdi-delete</v-icon>Eliminar contacto</v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-menu>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </template>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels> -->
            <!-- end contacts -->

          <!-- related documents -->
          <v-card flat>
            <v-card-text class="pa-0">
                <v-row no-gutters align="center" justify="space-between">
                  <v-col class="px-5 py-4">
                    <span class="subtitle-2 grey-500--text font-weight-bold"><v-icon size="18" left color="grey-500">mdi-file-document-multiple</v-icon>Documentos recibidos</span>
                  </v-col>
                </v-row>
                <v-divider />
                <purchase-list :loading="purchaseLoading" :show-pagination="false" />
                <template v-if="purchasesList?.length">
                  <v-divider />
                  <v-row class="px-4 pt-4 pb-2" align="center">
                    <v-btn class="ml-5 body-1" :to="{name: 'PurchaseList', params: $route.params, query: { tax_id: cleanTaxId }}" :ripple="false" text color="blue-500">Ver todos los documentos</v-btn>
                  </v-row>
                </template>
              </v-card-text>
            </v-card>
            <!-- end related documents -->

            <!-- related documents pending -->
            <v-card flat class="mt-6" v-if="$store?.state?.auth?.account?.options?.includes('pending_documents')">
              <v-card-text class="pa-0">
                  <v-row no-gutters align="center" justify="space-between">
                    <v-col class="px-5 py-4">
                      <span class="subtitle-2 grey-500--text font-weight-bold"><v-icon size="18" left color="grey-500">mdi-file-document-multiple</v-icon>Documentos pendientes de recibir</span>
                    </v-col>
                  </v-row>
                  <v-divider />
                  <purchase-pending-list :loading="siiLoading" :show-pagination="false" />
                  <template v-if="purchasesSiiList?.length">
                    <v-divider />
                    <v-row class="px-4 pt-4 pb-2" align="center">
                      <v-btn class="ml-5 body-1" :to="{name: 'PendingReceiveList', query: { tax_id: cleanTaxId }}" :ripple="false" text color="blue-500">Ver todos los documentos</v-btn>
                    </v-row>
                  </template>
                </v-card-text>
              </v-card>
              <!-- end related documents pending -->
          </div>
          <!-- end panels -->
        </template>
      </div>
    </v-col>

    <!-- dialog confirm lock -->
    <v-dialog v-model="dialogConfirmLock" width="838" persistent no-click-animation overlay-color="grey-500">
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="46" class="transparent">
            <v-toolbar-title class="px-5 subtitle-2 grey-500--text font-weight-semibold">{{ currentSegment?.name !== 'Bloqueados' ? 'Bloquear' : 'Desbloquear' }} proveedor</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-3">
                <v-btn @click="dialogConfirmLock = false" icon small retain-focus-on-click><v-icon color="grey-500" size="20">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="py-4 px-5 grey-500--text">
          <v-row class="pt-2" align="center">
            <v-col cols="3">
              <img :src="require(`@/assets/backgrounds/modal-el-lock.svg`)" :width="178" />
            </v-col>
            <v-col class="pr-4 body-1 pl-6">
              <template v-if="currentSegment?.name !== 'Bloqueados'">
                Al bloquear el proveedor todos los nuevos documentos seran reclamadas automaticamente.

                <span class="d-block body-1 pt-3">Puedes desbloquear al proveedor y asignarlo a cualquier categoria cuando lo desees.</span>
              </template>
              <span class="d-block body-1 pt-3" v-else>Al desbloquear el proveedor no tendra categorias asociadas y estara sujeto a las reglas de automatizacion para proveedores sin categorias. Podra ser asignado a otras categorias en el futuro.</span>
              <span class="d-block body-1 mt-4 mb-3">Escribe <span class="font-weight-bold">"confirmar"</span> para continuar.</span>
              <v-text-field v-model="confirm" outlined single-line maxlength="9" dense hide-details @keyup.enter="confirm.toLowerCase() === 'confirmar' && (dialogConfirmLock = false, toggleBlock())" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions class="py-2 px-5">
          <v-spacer />
          <v-btn @click="dialogConfirmLock = false" outlined>Cancelar</v-btn>
          <v-btn color="blue-500" @click="dialogConfirmLock = false, toggleBlock()" :loading="$store.state.irs.createLoader" :disabled="confirm.toLowerCase() !== 'confirmar'">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog confirm lock -->

    <!-- dialog confirm destroy group -->
    <SupplierDeleteCategoryModal
      v-if="$store?.state?.auth?.account?.options?.includes('rec_process_rules')"
      v-model="dialogDelete"
      :supplier="instance"
      @confirm="handleDeleteConfirm"
    />
    <!-- end dialog confirm destroy group -->

    <!-- dialog add/change category -->
    <SupplierCategoryModal
      v-if="$store?.state?.auth?.account?.options?.includes('rec_process_rules')"
      v-model="dialogAddCategory"
      :action-type="actionType"
      :supplier="instance"
      :categories-list="segmentsList"
      :loading="createCategoryLoading"
      @confirm="handleCategoryConfirm"
    />
    <!-- end dialog add/change category -->

    <!--modal update supplier-->
    <v-dialog v-model="dialogSupplier" width="700" persistent no-click-animation scrollable overlay-color="grey-500">
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="46" class="transparent">
            <v-toolbar-title class="px-5 subtitle-2 grey-500--text font-weight-semibold">Editar proveedor</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-3">
                <v-btn class="ml-3" @click="dialogSupplier=false" icon small retain-focus-on-click><v-icon color="grey-500" size="20">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="py-4 px-0 overflow-y-auto" style="max-height: 710px;" min-height="700" scrollable>
          <v-col class="font-weight-bold d-flex align-center body-1 px-5 pt-0 text-500--text">
            <v-icon color="grey-500" size="18" left>mdi-human-dolly</v-icon>
            <span class="subtitle-2 grey-500--text font-weight-semibold">Información del proveedor</span>
          </v-col>
          <v-row class="px-5" no-gutters>
            <v-col cols="3" class="pa-0">
              <span class="grey-500--text body-1">{{$t('generals.RUT')}}</span>
              <v-text-field v-model="editable.tax_id" readonly disabled v-dni="$store?.state?.auth?.account?.country" outlined single-line dense hide-details />
            </v-col>
            <v-col class="pa-0 ml-3">
              <span class="grey-500--text body-1">Nombre de la empresa</span>
              <v-text-field v-model.trim="$v.editable.name.$model" :error="$v.editable.name.$error" outlined single-line dense maxlength="100" hide-details />
            </v-col>
          </v-row>
          <v-col class="px-5">
            <span class="grey-500--text body-1">Actividad económica</span>
            <v-text-field v-model="editable.business_activity" outlined single-line dense maxlength="64" hide-details />
          </v-col>
          <v-row class="px-5 pb-0" no-gutters>
            <v-col cols="8" class="pa-0">
              <span class="grey-500--text body-1">Dirección</span>
              <v-text-field v-model.trim="editable.address" outlined single-line dense maxlength="64" hide-details />
            </v-col>
            <v-col class="pa-0 ml-3">
              <span class="grey-500--text body-1">{{$t('generals.Comuna')}}</span>
              <v-text-field v-model.trim="editable.municipality" outlined single-line dense maxlength="64" hide-details />
            </v-col>
          </v-row>
          <v-row class="px-5 pt-3" no-gutters>
            <v-col cols="12" class="pa-0">
              <span class="grey-500--text body-1">Ciudad</span>
              <v-text-field v-model.trim="editable.city" outlined single-line dense maxlength="64" hide-details />
            </v-col>
          </v-row>
          <template v-if="$store?.state?.auth?.account?.options?.includes('rec_process_rules')">
            <v-divider class="my-4" />
            <div class="px-5 py-1">
              <v-toolbar-title class="px-0 mb-3 subtitle-2 grey-500--text font-weight-semibold">
                <v-icon color="grey-500" size="18" left>mdi-account-multiple</v-icon>
                <span class="subtitle-2 grey-500--text font-weight-semibold">Selecciona la categoría a la que quieres asignar al proveedor</span>
                <v-chip class="ml-2 px-1 font-weight-regular" x-small color="grey-background">Opcional</v-chip>
              </v-toolbar-title>
              <div class="pa-0">
                <span class="grey-500--text body-1">Categorías</span>
                <v-col class="pa-0">
                  <v-select
                    v-model="editable.segment_id"
                    hide-details
                    single-line
                    color="blue-500"
                    dense
                    outlined
                    clearable
                    :items="filteredSegmentsListForEdit"
                    :chips="false"
                    item-text="name"
                    item-value="id"
                    item-disabled="disabled"
                    no-data-text="No existen categorías para mostrar"
                    :menu-props="{ bottom: true, offsetY: true, maxHeight: 200 }"
                  />
                </v-col>
              </div>
            </div>
          </template>
        </v-card-text>
        <v-divider />
        <v-card-actions class="px-5 py-2">
          <v-spacer/>
          <v-btn outlined @click="dialogSupplier=false">Cancelar</v-btn>
          <v-btn color="blue-500" :loading="$store.state.suppliers.createLoader" @click="updateSupplier">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end modal update supplier -->
  </v-row>
</template>

<script>
  import { mapState } from 'vuex'
  import VEmptyState from '@/components/commons/VEmptyState'
  import MiniHeader from '@/components/commons/MiniHeader'
  import cloneDeep from 'lodash/cloneDeep'
  import { required, maxLength } from 'vuelidate/lib/validators'
  import SkeletonDetail from '@/components/commons/skeletonLoader/SkeletonDetail'
  import PurchaseList from '@/modules/purchase/components/PurchaseList'
  import PurchasePendingList from '@/modules/purchase/pending-receive/components/PendingReceiveList'
  import GenericViewMixin from '@/mixins/GenericViewMixin'
  import RenderViewMixin from '@/mixins/RenderViewMixin'
  import TaxAgencyViewMixin from '@/mixins/TaxAgencyViewMixin'
  import PermissionDenied from '@/modules/http/views/PermissionDenied'
  import SupplierCategoryModal from '@/modules/supplier/components/SupplierCategoryModal'
  import SupplierDeleteCategoryModal from '@/modules/supplier/components/SupplierDeleteCategoryModal'

  export default {
    mixins: [
      GenericViewMixin,
      RenderViewMixin,
      TaxAgencyViewMixin
    ],
    components: {
      SkeletonDetail,
      PurchaseList,
      MiniHeader,
      PermissionDenied,
      PurchasePendingList,
      VEmptyState,
      SupplierCategoryModal,
      SupplierDeleteCategoryModal
    },
  data: () => ({
    statusChip: {
      accept: {
        key: 'Acepta',
        color: 'blue-100',
        icon: 'file-check'
      },
      reject: {
        key: 'Reclama',
        color: 'red-100',
        icon: 'file-remove'
      },
      nothing: {
        key: 'Mantiene igual',
        color: 'yellow-100',
        icon: 'file-clock'
      },
      '': {
        key: 'Desactivada',
        color: 'grey-500',
        icon: 'cancel'
      }
    },
    contactPanel: 0,
    contactsLoading: false,
    actionType: 'add',
    dialogSupplier: false,
    contacts: [{ name: '', email: '', phone: '' }],
    dialogAddCategory: false,
    createCategoryLoading: false,
    dialogConfirmLock: false,
    dialogDelete: false,
    confirm: '',
    scroll: 0,
    comments: '',
    dialogSwap: false,
    loading: false,
    panelIrsSii: [],
    panelComments: false,
    panelEmail: false,
    panelPDF: false,
    panelRelatedDocuments: 0,
    isAccept: false,
    purchaseLoading: false,
    siiLoading: false,
    dialogConfirm: false,
    currentList: [],
    current: {},
    breadcrumbs: {
      main: 'Recepción',
      children: [
        {
          text: 'Proveedores',
          route: 'SupplierListCreate'
        }
      ]
    },
    editable: {
      name: '',
      tax_id: '',
      address: '',
      business_activity: '',
      municipality: '',
      city: '',
      segment_id: null
    }
  }),
  computed: {
    ...mapState({
      count: state => state.purchases.recdocsCount,
      purchasesList: state => state.purchases.recdocsList,
      instance: state => state.suppliers.suppliersDetail,
      segmentsList: state => state.suppliers.segmentsList,
      purchasesSiiList: state => state.purchases.woemailList
    }),
    isFixed () {
      return !this.instance?.segment_id ? 'position:fixed!important;' : ''
    },
    currentSegment () {
      if (!this.instance?.segment_id || this.instance.segment_id === 'se_AAAAAAAAAAAAAAAA') return null
      return this.segmentsList.find(segment => segment.id === this.instance.segment_id) || null
    },
    isDefaultCategory () {
      return !this.instance?.segment_id || this.instance.segment_id === 'se_AAAAAAAAAAAAAAAA'
    },
    filteredSegmentsListForEdit () {
      return this.segmentsList.map(segment => ({
        ...segment,
        name: segment.id === 'se_AAAAAAAAAAAAAAAA' ? 'Sin categoría' : segment.name,
        disabled: segment.id === 'se_AAAAAAAAAAAAAAAA'
      }))
    },
    cleanTaxId () {
      return this.instance.tax_id?.replace(/\./g, '') || ''
    }
  },
  async created () {
    await this.getList()
    if (this.$helpers.hasPermission(['view_purchase'])) {
      this.purchaseLoading = true
      this.$store.dispatch('purchases/LIST', {
        resource: 'rec-docs',
        query: {
          tax_id: this.cleanTaxId,
          page_size: 6
        }
      })
      .finally(() => {
        this.purchaseLoading = false
      })
      this.siiLoading = true
      this.$store.dispatch('purchases/LIST', {
        resource: 'rec-docs/woemail',
        query: {
          tax_id: this.cleanTaxId,
          page_size: 6
        }
      })
      .finally(() => {
        this.siiLoading = false
      })
    }
    if (this.$helpers.hasSomePermission(['view_suppliergroup'])) {
      this.$store.dispatch('suppliers/LIST', {
      resource: 'segments',
      query: {
          page_size: 9999
        }
      })
    }
  },
  methods: {
    currentParams () {
      let params = JSON.parse(JSON.stringify(this.$route.params))
      delete params.id
      return params
    },
    openEditDialog () {
      this.$store.dispatch('suppliers/LIST', {
        resource: 'segments',
        query: {
          page_size: 9999
        }
      })
      this.dialogSupplier = true
    },
    addRowContacts () {
      this.contacts.push({
        name: '',
        email: '',
        phone: ''
      })
    },
    getList () {
      this.loading = true
      return this.$store.dispatch('suppliers/RETRIEVE', {
        resource: 'suppliers',
        id: this.$route.params.id
      })
      .then(() => {
        const supplier = cloneDeep(this.instance)
        this.editable = supplier
      })
      .finally(() => {
        this.loading = false
      })
    },
    clearInput () {
      this.$v.editable.$reset()
      this.editable = {
        name: '',
        tax_id: '',
        address: '',
        business_activity: '',
        municipality: '',
        city: '',
        segment_id: null
      }
    },
    onScroll (e) {
      this.scroll = e.target?.scrollingElement?.scrollTop ?? 0
    },
    handleDelete () {
      this.dialogDelete = true
    },
    handleAdd () {
      this.actionType = 'add'
      this.$store.dispatch('suppliers/LIST', {
        resource: 'segments',
        query: {
          page_size: 9999
        }
      })
      this.dialogAddCategory = true
    },
    handleChange () {
      this.actionType = 'change'
      this.$store.dispatch('suppliers/LIST', {
        resource: 'segments',
        query: {
          page_size: 9999
        }
      })
      this.dialogAddCategory = true
    },
    async handleCategoryConfirm ({ supplier, newCategoryId, oldCategoryId, actionType }) {
      this.createCategoryLoading = true
      try {
        if (actionType === 'change') {
          await this.$store.dispatch('suppliers/UPDATE', {
            resource: `suppliers/${supplier.id}/replace-segment`,
            payload: {
              old_segment_id: oldCategoryId,
              new_segment_id: newCategoryId
            }
          })
        } else {
          await this.$store.dispatch('suppliers/UPDATE', {
            resource: `suppliers/${supplier.id}/replace-segment`,
            payload: {
              old_segment_id: oldCategoryId || 'se_AAAAAAAAAAAAAAAA',
              new_segment_id: newCategoryId
            }
          })
        }
        this.$dialog.message.info(actionType === 'change' ? 'La categoría ha sido cambiada correctamente.' : 'El proveedor ha sido asignado correctamente a la categoría.')
        this.getList()
      } catch (error) {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      } finally {
        this.dialogAddCategory = false
        this.createCategoryLoading = false
      }
    },
    toggleBlock () {
      this.$store.dispatch('suppliers/CREATE', {
        resource: `suppliers/${this.$route.params.id}/toggle_block`
      })
      .then(() => {
        this.getList()
        this.$dialog.message.info(`El proveedor ha sido ${this.instance.group.name === 'Bloqueados' ? 'desbloqueado' : 'bloqueado'} con exito`)
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
      .finally(() => {
        this.confirm = ''
      })
    },
    handleDeleteConfirm ({ supplier, categoryId }) {
      this.$store.dispatch('suppliers/UPDATE', {
        resource: `suppliers/${supplier.id}/remove-segment`,
        payload: {
          segment_id: categoryId
        }
      })
      .then(() => {
        this.$dialog.message.info('El proveedor se ha eliminado de la categoría con éxito')
        this.getList()
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
      .finally(() => {
        this.dialogDelete = false
      })
    },
    getContacts () {
      this.contactsLoading = true
        this.$store.dispatch('suppliers/LIST', {
        resource: 'suppliers/contacts',
          query: {
            supplier: this.$route.params.id
        }
      })
      .then((response) => {
        if (response.data.results.length) {
          this.contacts = cloneDeep(response.data.results)
        }
      })
      .finally(() => {
        this.contactsLoading = false
      })
    },
    async updateSupplier () {
      this.$v.editable.$touch()
      if (this.$v.editable.$invalid) {
        return false
      }
      const payload = {
        name: this.editable.name,
        address: this.editable.address,
        business_activity: this.editable.business_activity,
        municipality: this.editable.municipality,
        city: this.editable.city
      }
      try {
        await this.$store.dispatch('suppliers/UPDATE', {
          resource: `suppliers/${this.$route.params.id}`,
          payload: payload
        })

        const oldSegmentId = this.instance.segment_id
        const newSegmentId = this.editable.segment_id

        if (oldSegmentId !== newSegmentId) {
          if (!oldSegmentId && newSegmentId) {
            await this.$store.dispatch('suppliers/UPDATE', {
              resource: `suppliers/${this.$route.params.id}/replace-segment`,
              payload: {
                old_segment_id: 'se_AAAAAAAAAAAAAAAA',
                new_segment_id: newSegmentId
              }
            })
          } else if (oldSegmentId && newSegmentId) {
            await this.$store.dispatch('suppliers/UPDATE', {
              resource: `suppliers/${this.$route.params.id}/replace-segment`,
              payload: {
                old_segment_id: oldSegmentId,
                new_segment_id: newSegmentId
              }
            })
          } else if (oldSegmentId && !newSegmentId) {
            await this.$store.dispatch('suppliers/UPDATE', {
              resource: `suppliers/${this.$route.params.id}/remove-segment`,
              payload: { segment_id: oldSegmentId }
            })
          }
        }

        this.getList()
        this.$dialog.message.info('El proveedor ha sido actualizado')
      } catch (error) {
        this.$dialog.message.error('Error al actualizar el proveedor.')
      } finally {
        this.dialogSupplier = false
      }
    },
    destroy (id) {
      if (id) {
        this.$store.dispatch('suppliers/DESTROY', {
          resource: 'suppliers/contacts',
          id: id
        })
        .then(() => {
          this.$dialog.message.info('El contacto ha sido eliminado')
          this.getContacts()
        })
        .catch(() => {
          this.$dialog.message.error('Error al eliminar el contacto.')
        })
      }
    }
  },
  validations: {
    editable: {
      name: { required, maxLength: maxLength(100) }
    }
  }
}
</script>
<style scoped>
.v-list--three-line .v-list-item .v-list-item__subtitle, .v-list-item--three-line .v-list-item__subtitle {
  -webkit-line-clamp: 2 !important;
}
.v-list--three-line .v-list-item, .v-list-item--three-line {
  min-height: auto;
}
</style>
